// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/pontio/assets/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}
body {
  height: 100%;
  margin: 0;
  background-color: #fcfcfc;
}

#root,
#app {
  height: 100%;
}
/* Auto fill chrome*/
input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition:
    background-color 600000s 0s,
    color 600000s 0s;
}

/* Ocultar los iconos de flecha */
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Agregar un icono personalizado como fondo */
input[type='date']::-webkit-calendar-picker-indicator {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 18px 18px;
  opacity: 0.7;
  cursor: pointer;
}

input[data-autocompleted] {
  background-color: transparent !important;
}
/* width */
::-webkit-scrollbar {
  width: 4px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#initproject .MuiPaper-root {
  height: 90%;
}

#fitcontent {
  width: fit-content;
  margin: auto;
  display: block;
}

#alert {
  padding: 0 !important;
}

#header .MuiListItemIcon-root {
  color: inherit;
}

.grecaptcha-badge {
  visibility: hidden;
}

#tableorders .MuiTableCell-root {
  padding: 4px;
}

.MuiTableContainer-root .MuiPaper-elevation {
  box-shadow: none;
}

.MuiButton-root.MuiButton-text {
  text-transform: none !important;
}
.MuiTableCell-root {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

.MuiSvgIcon-fontSizeLarge {
  font-size: 6rem !important;
}

.MuiDialog-container .MuiPaper-root#statepopup {
  color: white;
  background-color: #264653;
}

#merchant .react-pdf__Page__canvas {
  margin: auto;
  width: 900px !important;
  height: auto !important;
}

.react-pdf__Page__canvas {
  width: 320px !important;
  height: auto !important;
  margin: auto;
}

#tech-form-content {
  scrollbar-color: #9cb0bc #e8ebed;
  scrollbar-width: thin;
  max-height: 24.9rem;
  min-height: 24.9rem;
  overflow: auto;
}

#scrollable-list {
  scrollbar-color: #9cb0bc #e8ebed;
  scrollbar-width: thin;
  max-height: 55%;
  min-height: 55%;
  overflow: auto;
}

/** --------------- ANIMATIONS ------------------------- **/

.zoom {
  animation: transaction 0.75s;
  animation-timing-function: ease-out;
}

@keyframes transaction {
  from {
    transform: scale(0.85);
    filter: blur(0.1rem);
  }
  to {
    transform: scale(1);
    filter: blur(0);
  }
}

/** --------------- GLOBAL CLASSES ------------------------- **/

.verticalAlign {
  display: flex;
  align-items: center;
}
.horizontalAlign {
  display: flex;
  justify-content: center;
}
.centerAlign {
  display: flex;
  align-items: center;
  justify-content: center;
}
.container {
  padding: 2rem;
  padding-top: 0;
  margin: 0;
}
.paper {
  background-color: #fffefe;
  padding: 1rem 2rem;
}
.standardButton {
  width: 15rem;
}

#crisp-chatbox a[data-type='email_invalid'] {
  display: none !important;
}

#checkpassgrid li {
  align-items: center !important;
}

#comment > div > div[class\$='MUIDataTable-liveAnnounce'] {
  display: none !important;
}

div [class*='MuiInputBase-root-MuiTablePagination-select'] {
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;AACA,oBAAoB;AACpB;;EAEE;;oBAEkB;AACpB;;AAEA,iCAAiC;AACjC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,oEAAsE;EACtE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;AACA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["html {\n  height: 100%;\n}\nbody {\n  height: 100%;\n  margin: 0;\n  background-color: #fcfcfc;\n}\n\n#root,\n#app {\n  height: 100%;\n}\n/* Auto fill chrome*/\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n  transition:\n    background-color 600000s 0s,\n    color 600000s 0s;\n}\n\n/* Ocultar los iconos de flecha */\ninput[type='date']::-webkit-inner-spin-button,\ninput[type='date']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Agregar un icono personalizado como fondo */\ninput[type='date']::-webkit-calendar-picker-indicator {\n  background: url('/public/pontio/assets/calendar.svg') no-repeat center;\n  background-size: 18px 18px;\n  opacity: 0.7;\n  cursor: pointer;\n}\n\ninput[data-autocompleted] {\n  background-color: transparent !important;\n}\n/* width */\n::-webkit-scrollbar {\n  width: 4px;\n  height: 5px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n#initproject .MuiPaper-root {\n  height: 90%;\n}\n\n#fitcontent {\n  width: fit-content;\n  margin: auto;\n  display: block;\n}\n\n#alert {\n  padding: 0 !important;\n}\n\n#header .MuiListItemIcon-root {\n  color: inherit;\n}\n\n.grecaptcha-badge {\n  visibility: hidden;\n}\n\n#tableorders .MuiTableCell-root {\n  padding: 4px;\n}\n\n.MuiTableContainer-root .MuiPaper-elevation {\n  box-shadow: none;\n}\n\n.MuiButton-root.MuiButton-text {\n  text-transform: none !important;\n}\n.MuiTableCell-root {\n  padding-top: 1px !important;\n  padding-bottom: 1px !important;\n}\n\n.MuiSvgIcon-fontSizeLarge {\n  font-size: 6rem !important;\n}\n\n.MuiDialog-container .MuiPaper-root#statepopup {\n  color: white;\n  background-color: #264653;\n}\n\n#merchant .react-pdf__Page__canvas {\n  margin: auto;\n  width: 900px !important;\n  height: auto !important;\n}\n\n.react-pdf__Page__canvas {\n  width: 320px !important;\n  height: auto !important;\n  margin: auto;\n}\n\n#tech-form-content {\n  scrollbar-color: #9cb0bc #e8ebed;\n  scrollbar-width: thin;\n  max-height: 24.9rem;\n  min-height: 24.9rem;\n  overflow: auto;\n}\n\n#scrollable-list {\n  scrollbar-color: #9cb0bc #e8ebed;\n  scrollbar-width: thin;\n  max-height: 55%;\n  min-height: 55%;\n  overflow: auto;\n}\n\n/** --------------- ANIMATIONS ------------------------- **/\n\n.zoom {\n  animation: transaction 0.75s;\n  animation-timing-function: ease-out;\n}\n\n@keyframes transaction {\n  from {\n    transform: scale(0.85);\n    filter: blur(0.1rem);\n  }\n  to {\n    transform: scale(1);\n    filter: blur(0);\n  }\n}\n\n/** --------------- GLOBAL CLASSES ------------------------- **/\n\n.verticalAlign {\n  display: flex;\n  align-items: center;\n}\n.horizontalAlign {\n  display: flex;\n  justify-content: center;\n}\n.centerAlign {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.container {\n  padding: 2rem;\n  padding-top: 0;\n  margin: 0;\n}\n.paper {\n  background-color: #fffefe;\n  padding: 1rem 2rem;\n}\n.standardButton {\n  width: 15rem;\n}\n\n#crisp-chatbox a[data-type='email_invalid'] {\n  display: none !important;\n}\n\n#checkpassgrid li {\n  align-items: center !important;\n}\n\n#comment > div > div[class$='MUIDataTable-liveAnnounce'] {\n  display: none !important;\n}\n\ndiv [class*='MuiInputBase-root-MuiTablePagination-select'] {\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
